import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useEligibility } from "@/contexts/EligibilityContext";
import { useEffect, useState } from "react";
import { CheckCircle, Circle, Clock } from "lucide-react";
import { cn } from "@/lib/utils";

const AssessmentTimeline = () => {
  const { getLatestAssessment } = useEligibility();
  const [assessment, setAssessment] = useState<any>(null);

  useEffect(() => {
    const fetchAssessment = async () => {
      const data = await getLatestAssessment();
      setAssessment(data);
    };
    fetchAssessment();
  }, [getLatestAssessment]);

  if (!assessment) return null;

  const stages = [
    {
      title: "Assessment Completed",
      date: new Date(assessment.created_at).toLocaleDateString(),
      status: "completed"
    },
    {
      title: "Document Review",
      date: assessment.results.overallScore >= 70 ? "Ready to proceed" : "Pending requirements",
      status: assessment.results.overallScore >= 70 ? "completed" : "pending"
    },
    {
      title: "Application Ready",
      date: assessment.results.overallScore >= 70 ? "Eligible to apply" : "Requirements not met",
      status: assessment.results.overallScore >= 70 ? "active" : "pending"
    }
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle>Assessment Timeline</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="relative space-y-4">
          {stages.map((stage, index) => (
            <div key={index} className="flex gap-4">
              <div className="flex flex-col items-center">
                <div className={cn(
                  "w-8 h-8 rounded-full flex items-center justify-center",
                  stage.status === "completed" && "bg-primary/20 text-primary",
                  stage.status === "active" && "bg-primary/10 text-primary animate-pulse",
                  stage.status === "pending" && "bg-muted text-muted-foreground"
                )}>
                  {stage.status === "completed" && <CheckCircle className="w-5 h-5" />}
                  {stage.status === "active" && <Clock className="w-5 h-5" />}
                  {stage.status === "pending" && <Circle className="w-5 h-5" />}
                </div>
                {index < stages.length - 1 && (
                  <div className="w-0.5 h-full bg-border" />
                )}
              </div>
              <div className="flex-1 pb-4">
                <p className="font-medium">{stage.title}</p>
                <p className="text-sm text-muted-foreground">{stage.date}</p>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default AssessmentTimeline;